<template>
  <b-container>

    <h1>Explore Public CitSci Data</h1>

    <div class="btn-toolbar float-right" style="margin-top:-64px;">
      <div class="btn-group" style="margin-right: 20px;">
        <button type="button" class="btn btn-secondary" id="ListViewButton" title="List View" alt="List View"><i
          class="fa fa-bars"></i></button>
        <button type="button" class="btn btn-secondary" id="GridViewButton" title="Table/Grid View" alt="Table/Grid View"
                disabled><i class="fa fa-table"></i></button>
        <button type="button" class="btn btn-secondary" id="CardViewButton" title="Card View" alt="Card View" disabled><i
          class="fa fa-th-large"></i></button>
        <button type="button" class="btn btn-secondary" id="MapViewButton" title="Map View" alt="Map View" disabled><i
          class="fa fa-map-marker "></i></button>
      </div>
    </div>

    <b-alert variant="danger" :show="!!error" dismissible>
      <font-awesome-icon icon="exclamation-triangle" /> {{ error }}
    </b-alert>

    <div class="card">
      <div class="card-header" style="background-color: #9DA3A8; padding: 0rem 0rem;">
        <h4 class="float-left mt-1"
            style="color:#ffffff; padding-top:4px; padding-bottom:0px; padding-left:10px; padding-right:12px;">
          Filters
        </h4>

        <b-button v-model="advFilterVisible" @click="advFilterVisible = !advFilterVisible" v-b-toggle.collapse-1
                  variant="secondary" class="float-left" style="margin-top: 4px;" alt="Show Advanced Filters"
                  title="Show Advanced Filters">
          <i :class="advFilterVisible ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
        </b-button>

        <b-form class="" v-on:submit.prevent="submit" action="#">
          <div class="input-group col-sm-5 float-left mt-1">
            <b-input-group-prepend>
            <span class="btn btn-secondary" alt="Start typing to search for citizen science observations"
                  title="Start typing to search for citizen science observations"><i class="fas fa-search"></i></span>
            </b-input-group-prepend>
            <b-form-input :disabled="isBusy" class="form-control" placeholder="Search by Location Name" name="search"
                          v-model="filterObject.filterText" debounce="500"></b-form-input>
            <div class="input-group-append" :style="{visibility: filterObject.filterText ? 'visible' : 'hidden'}">
              <b-button :disabled="!filterObject.filterText" @click="filterObject.filterText=null"><i
                class="fas fa-times-circle"></i></b-button>
            </div>
          </div>
        </b-form>

        <div class="btn-group mr-1 float-right" style="margin-top:4px;">
          <div class="mr-2 label-text" style="float: left; margin-top: 6px; color:#ffffff;"></div>
          <!-- <button type="button" class="btn btn-secondary" id="AllObservationsButton" title="Show All Observations" alt="Show All Observations"><i class="fa fa-bars"><span class="ml-2 label-text">All</span></i></button> -->
          <button type="button" class="btn btn-secondary" id="NewestObservationsButton" title="Show Newest Observations"
                  alt="Show Newest Observations" @click="sortBy='observedAt'" :disabled="sortBy==='observedAt'">
            <i class="fa fa-star"><span class="ml-2 label-text">Newest</span></i>
          </button>
          <button type="button" class="btn btn-secondary" id="FeaturedObservationsButton"
                  title="Show Featured Observations (coming soon)" alt="Show Featured Observations" disabled><i
            class="fa fa-star-o"><span class="ml-2 label-text">Featured</span></i></button>
        </div>

      </div>

      <b-collapse id="collapse-1" class="" style="background-color:#E7EBD2;">
        <!-- visible #E5EBDD -->
        <div class="card-body">

          <form>
            <div class="form-row">
              <div class="col-6">
                <div>
                  <b-form-group label-cols="4" label-cols-lg="4" label-size="lg" label="Project" label-for="input-sm">
                    <b-form-input id="input-sm" size="lg" placeholder="Coming soon" disabled></b-form-input>
                  </b-form-group>
                  <b-form-group label-cols="4" label-cols-lg="4" label-size="lg" label="Organization"
                                label-for="input-sm">
                    <!-- <multiselect v-model="filterObject.filterOrg"
                                   :options="organizationsArray" label="name" track-by="name"
                                   select-label="" deselect-label="" :block-keys="['Tab']" :multiple="false"
                                   :taggable="false" placeholder="Select an Organization (Coming soon)" disabled>
                      </multiselect> -->
                  </b-form-group>
                </div>
              </div>
              <div class="col-6">
                <div>
                  <b-form-group label-cols="4" label-cols-lg="4" label-size="lg" label="Person" label-for="input-default">
                    <b-form-input id="input-default" size="lg" placeholder="Coming soon" disabled></b-form-input>
                  </b-form-group>

                  <b-form-group label-cols="4" label-cols-lg="4" label-size="lg" label="Keyword/Tag" label-for="input-lg">
                    <b-form-input id="input-lg" size="lg" placeholder="Coming soon" disabled></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </form>

        </div>
      </b-collapse>
    </div>

    <b-container fluid style="padding-right: 0px; padding-left: 0px;">

      <!-- Show pagination and per page selection if #items exceeds 10 -->
      <b-container v-if="perPage > 10" class="mx-auto">
        <b-row class="mx-auto" align-h="between">

          <b-col v-if="(totalRows > 0)" cols md="3" class="my-1">
            Showing {{ fromItem }} to {{ toItem }} of {{ totalRows }} observations
          </b-col>

          <b-col sm="2" md="3" class="my-1">
            <b-pagination v-if="!isBusy" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                          class="my-0 pagination-holder" prev-text="Prev" next-text="Next" align="fill" />
          </b-col>

          <b-col sm="2" md="3" class="my-1">
            <b-form-group label="Per Page" label-align="right" label-cols-sm="7" label-cols-md="8"
                          label-for="perPageSelect" class="mb-0">
              <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions" align="right">
              </b-form-select>
            </b-form-group>
          </b-col>

        </b-row>
      </b-container>

      <!-- Main table element -->
      <div class="mt-4">
        <b-table ref="observationsAllTable" show-empty hover :sticky-header=true stacked="lg" :items="myProvider"
                 :fields="allObservationsListFields" :busy="isBusy" :current-page="currentPage" :per-page="perPage"
                 :total-rows="totalRows" :filter="filterVal" sort-icon-left :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                 :sort-direction="sortDirection" :striped="false" :empty-text="emptyText"
                 :empty-filtered-text="emptyFilteredText" @filtered="onFiltered">

          <template #head(observedAt)>
            <span id="public-observations-start-header" class="d-inline-flex align-items-center">
              Observation Date
              <i class="fa fa-question-circle ml-1 text-muted"></i>
            </span>
            <b-tooltip target="public-observations-start-header" placement="top" triggers="hover focus">
              Start date of the observation
            </b-tooltip>
          </template>

          <template v-slot:empty="scope">
            <h6 align="center">{{ scope.emptyText }}</h6>
          </template>

          <template v-if="filterVal" v-slot:empty="scope">
            <h6 align="center">{{ scope.emptyFilteredText }}</h6>
          </template>

          <template v-slot:cell(observedAt)="row">
            {{ row.item.observedAt ? displayDate(row.item.observedAt) : "-" }}
          </template>

          <!--        <template v-slot:cell(photo)="row">-->
          <!--          <div v-for="rec in firstImageRecord(row.item.records)">-->
          <!--            <b-row class="mx-auto fit-content">-->
          <!--              <b-col class="mx-0 px-0 overflow-hidden"-->
          <!--                     style="max-height: 68px; max-width: 100px;">-->
          <!--                <b-img class="mx-0 h-100" rounded="0"-->
          <!--                       :src="rec.files[0].path"-->
          <!--                       alt="Observation Image" />-->
          <!--              </b-col>-->
          <!--            </b-row>-->
          <!--          </div>-->
          <!--        </template>-->

          <template v-slot:cell(options)="row">
            <div class="options-holder">
              <b-btn class="mt-1 mr-1" alt="View Observation" title="View Observation"
                     :to="{ name: 'ObservationShow', params: { id: row.item.id } }">
                <font-awesome-icon icon="eye" /> View
              </b-btn>
            </div>
          </template>
          <template #table-busy>
            <VueLoader style="height:500px;" text="Loading Observations..." />
          </template>

        </b-table>
      </div>

      <b-container class="mx-auto">
        <b-row class="mx-auto" align-h="between">

          <b-col v-if="(totalRows > 0)" cols md="3" class="my-1">
            Showing {{ fromItem }} to {{ toItem }} of {{ totalRows }} observations
          </b-col>

          <b-col sm="2" md="3" class="my-1">
            <b-pagination v-if="!isBusy" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                          class="my-0 pagination-holder" prev-text="Prev" next-text="Next" align="fill" />
          </b-col>

          <b-col sm="2" md="3" class="my-1">
            <b-form-group label="Per Page" label-align="right" label-cols-sm="7" label-cols-md="8"
                          label-for="perPageSelect" class="mb-0">
              <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions" align="right">
              </b-form-select>
            </b-form-group>
          </b-col>

        </b-row>
      </b-container>

    </b-container>

  </b-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import VueLoader from "../layout/Loader.vue";

export default {
  components: {
    VueLoader
  },

  data () {
    return {
      observationsAll: [],
      selected: null,
      options: [
        { value: null, text: 'Please select a project' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'This is Second option' },
        { value: 'c', text: 'This is Third option' },
        { value: 'd', text: 'Disabled option', disabled: true }
      ],

      isBusy: false,
      emptyText: "No Observations Available",
      emptyFilteredText: "No Observations Available for Search Criteria",
      originalItemCount: 0,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: 'observedAt',
      sortDesc: true,
      sortDirection: 'desc',
      filterObject: {
        filterText: null,
      },

      // Boolean indicating if the advanced filter is toggled
      advFilterVisible: false,

      allObservationsListFields: [
        { key: 'observedAt', label: 'Observation Date', sortable: true,  formatter: (val) => { return this.displayDate(val) } },
        { key: 'projectName', label: 'Project Name', sortable: true, formatter: (val, fieldName, item) => { return item && item.project && this.ellipsizeCharacters(item.project.name,45) } },
        { key: 'locationName', label: 'Location Name', sortable: true, formatter: (val, fieldName, item) => { return item && item.location && this.ellipsizeCharacters(item.location.name,45) } },
        { key: 'locationLatitude', label: 'Latitude', sortable: true, formatter: (val, fieldName, item) => {
            if (item.project.isPrivate) return 'private'
            else return item && item.lngLat && item.lngLat.lat
          } },
        { key: 'locationLongitude', label: 'Longitude', sortable: true, formatter: (val, fieldName, item) => {
            if (item.project.isPrivate) return 'private'
            else return item && item.lngLat && item.lngLat.lng
          } },
        //{ key: 'createdAt', label: 'Created Date', sortable: true, tdClass: 'color-gray',  formatter: (val) => { return this.displayDate(val) } },
        // { key: 'photo', label: 'Photo', sortable: false },
        { key: 'options', label: 'Options', tdClass: 'color-blue', thStyle: { width: '190px!important'} }
      ],

    }
  },

  mounted() {
    // Set the initial number of projects
    this.totalRows = this.observationsAll.length
  },

  computed: {
    ...mapGetters({
      error: 'observation/list/error',
      isLoading: 'observation/list/isLoadingAll',
    }),

    filterVal: {
      get: function() {
        // This is our multi-filter computed value
        // - search the name of the location
        //More filters can be added here

        let retVal = ''
        if (this.filterObject.filterText) {
          retVal = retVal.length === 0 ? 'location.name=' + this.filterObject.filterText : '&location.name=' + this.filterObject.filterText
        }

        return retVal
      }
    },

    fromItem () {
      // Computed value for showing lower bound based on current page and per page value
      return this.totalRows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0
    },

    toItem () {
      // Computed value for showing upper bound based on current page and per page value
      return this.totalRows < (this.currentPage * this.perPage) ? this.totalRows : this.currentPage * this.perPage
    },

  },

  methods: {
    ...mapActions({
      getItems: 'observation/list/getAllObservationsList',
    }),

    myProvider(ctx, callback) {

      // Busy state is set
      this.isBusy = true

      // Per page value is set for the initial call when table is mounted
      if (ctx.perPage === 0) {
        ctx.perPage = 10
      }

      // Set the callback at all times
      let _callback = null
      if (!callback) {
        _callback = this.providerCallback
      }
      if (typeof callback === 'function') {
        _callback = callback
      }

      // URL Params are built
      let urlParams = this.urlBuilder(ctx)

      // Observations are fetched from API
      try {
        this.getItems({ urlParams: urlParams }).then(data => {

          // Total rows are set
          this.totalRows = data['hydra:totalItems']
          this.originalItemCount = this.totalRows
          // Pluck the array of observations off our response
          const items = data['hydra:member']

          // Provide the array of items to the callback
          _callback(items)
        })
      } catch (e) {
        console.log('An error occurred on getting data from API')
        _callback([])
      }

      // Busy state is unset
      this.isBusy = false

      // Must return null or undefined to signal b-table that callback is being used
      return null

    },

    providerCallback(items) {
      // This is the callback which refreshes the table with the newly fetched items
      this.observationsAll = []
      this.observationsAll =  (items && items.length > 0) ? items.slice() : []
      this.$refs.observationsAllTable.refresh()
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (this.totalRows !== filteredItems.length && filteredItems.length > this.perPage) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    },

    firstImageRecord(records) {
      let bFirst = false
      return records.filter((rec) => {
        if (rec.recordType === 'image' && !bFirst) {
          bFirst = true
          return rec
        }
      })
    },

    /**
     * Button click handler
     * @function onClickViewObservation
     * @param event
     * @param item
     */
    /*
   onClickViewObservation(evt, item) {
     evt.preventDefault()
     this.$router.push({name: 'ObservationShow', params: { id: item.id}})
   },
   */

  },

}
</script>
<style lang="scss" scoped>
.paddingBottom10px {
  padding-bottom: 11px;
}

.label-text {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
}

@media screen and (max-width: 1190px) {
  .label-text {
    display: none;
  }
}

#AddProjectButton{
  background-color: #00B0F0;
  border: solid 1px #00B0F0;
}

#AddProjectButton:hover{
  background-color: #87983F;
  border: solid 1px #87983F;
}

#SearchProjectsButton{
  background-color: #6C757D;
  border: solid 1px #6C757D;
}

#SearchProjectsButton:hover{
  background-color: #5A6268;
  border: solid 1px #5A6268;
}

.btn-secondary:disabled{
  cursor:not-allowed;
}
</style>
